enum API {
	LOG = '/api/settings/requestLog'
}

export default API;
